export type PwaTheme = 'dark' | 'light';

export const PWA_THEME_STORAGE_KEY = 'va_pwa_theme';
const LEGACY_CHAT_THEME_KEY = 'va_pwa_chat_theme';

export function readStoredPwaTheme(): PwaTheme {
  try {
    const current = localStorage.getItem(PWA_THEME_STORAGE_KEY);
    if (current === 'light' || current === 'dark') return current;
    const legacy = localStorage.getItem(LEGACY_CHAT_THEME_KEY);
    if (legacy === 'light' || legacy === 'dark') return legacy;
  } catch {
    /* ignore */
  }
  return 'dark';
}

export function writeStoredPwaTheme(theme: PwaTheme): void {
  try {
    localStorage.setItem(PWA_THEME_STORAGE_KEY, theme);
    localStorage.setItem(LEGACY_CHAT_THEME_KEY, theme);
  } catch {
    /* ignore */
  }
}

export function applyPwaThemeToDocument(theme: PwaTheme): void {
  document.documentElement.dataset.pwaTheme = theme;
  document.documentElement.style.colorScheme = theme;
}
